import { fetchOne } from "actions/resources";

export function removeTFA(userId) {
  return dispatch => dispatch({
    CALL_API: {
      method: "delete",
      endpoint: `/users/${userId}/2fa/`,
      types: ["DISABLE_TFA_REQUEST", "DISABLE_TFA_SUCCESS", "DISABLE_TFA_FAILURE"],
      dispatchCallbacks: [{
        request() {
          return dispatch(fetchOne("user"));
        },
        fireOnStatus: "success"
      }]
    }
  });
}

export function setSettingsSecurityState(change) {
  return {
    type: "SET_SETTINGS_SECURITY",
    change
  };
}
